import {
  AttachmentIcon,
  GPTIcon,
  GridIcon,
  ListIcon,
  LomaIcon,
  ReportIcon,
} from "src/components/icons/NavIcons";
import Koti_NavContainer from "../components/Koti_NavContainer";
import { SearchIcon } from "src/components/icons/SearchIcons";
import { useEffect, useState } from "react";
import { WorkIcon } from "src/components/icons/ReportIcons";
import { MapIcon } from "src/components/icons/MapIcons";

const styles = {
  main: {
    width: "100%",
    gap: 14,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  sub: {
    width: "100%",
    gap: 20,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
  },
};

export default function Koti_NavContainers() {
  const [starred, setStarred] = useState("/");

  useEffect(() => {
    const _url = localStorage.getItem("defaultUrl");
    if (_url) setStarred(_url);
  }, []);

  const handleSetStarredClick = (url) => {
    if (url === starred) url = "/koti"; // if same url, star is removed, set default url to /koti
    setStarred(url);
    localStorage.setItem("defaultUrl", url);
  };
  const handleSetTyotClick = (url) => {
    if (url === starred) url = "/tyot"; // if same url, star is removed, set default url to /koti
    setStarred(url);
    localStorage.setItem("defaultUrl", url);
  };

  return (
    <div style={styles.main}>
      <Koti_NavContainer
        icon={<WorkIcon />}
        title="Työt"
        desc="Omat työt ja tehtävät"
        isStarred={starred === "/tyot"}
        setStarred={handleSetTyotClick}
        size="wide"
        page="tyot"
      />
      <div style={styles.sub}>
        <Koti_NavContainer
          icon={<ListIcon />}
          title="Tilauslista"
          desc="Lista kaikista tilauksista"
          isStarred={starred === "/list"}
          setStarred={handleSetStarredClick}
          size="large"
          page="list"
        />
        <Koti_NavContainer
          icon={<GridIcon />}
          title="Tilauskalenteri"
          desc="Päivä- ja ajoneuvokohtainen tilauskalenteri"
          isStarred={starred === "/grid"}
          setStarred={handleSetStarredClick}
          size="large"
          page="grid"
        />
      </div>
      <div style={styles.sub}>
        <Koti_NavContainer
          icon={<MapIcon />}
          title="Kartta"
          desc="Ajoneuvot kartalla"
          isStarred={starred === "/kartta"}
          setStarred={handleSetStarredClick}
          page="map"
        />
        <Koti_NavContainer
          icon={<ReportIcon />}
          title="Raportit"
          desc="Raportit, tulosteet ja tilastot"
          isStarred={starred === "/raport"}
          setStarred={handleSetStarredClick}
          page="raport"
        />
        <Koti_NavContainer
          icon={<LomaIcon />}
          title="Lomat"
          desc="Hallitse poissaoloja ja lomia"
          isStarred={starred === "/lomat"}
          setStarred={handleSetStarredClick}
          page="loma"
        />
        <Koti_NavContainer
          icon={<AttachmentIcon />}
          title="Liitteet"
          desc="Selaile ja tallenna liitetiedostoja"
          isStarred={starred === "/liite"}
          setStarred={handleSetStarredClick}
          page="liite"
        />
        <Koti_NavContainer
          icon={<GPTIcon fontSize={"30px"} />}
          title="AI"
          desc="Tekoäly gpt-4o"
          isStarred={starred === "/ai"}
          setStarred={handleSetStarredClick}
          page="ai"
        />
        <Koti_NavContainer
          icon={<SearchIcon />}
          title="Haku"
          desc="Hae työmaata, asiakasta, henkilöä, tilausta tai liitettä"
          isStarred={starred === "/haku"}
          setStarred={handleSetStarredClick}
          page="haku"
        />
      </div>
    </div>
  );
}
